import filesApi from '.'
import { getAuthHeaders } from 'utils/requests'

const viewFile = async (id) => {
  const headers = { headers: getAuthHeaders() }
  return await filesApi.get(`/${id}/view`, headers)
}

export default viewFile
